// @ts-nocheck
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useAutomation = () => {
  const permissions = useSelector((state) => state.app?.permissions || []);
  const hasAutomation = useMemo(() => {
    return permissions.includes('AUTOMATION_SUITE');
  }, [permissions]);

  return {
    hasAutomation,
  };
};

export const checkAutomation = (permissions) =>
  permissions?.includes('AUTOMATION_SUITE') || false;
